import { useAuth } from "../../auth/context";
import HomologarApi from "../../apis/homologarApi";

const useHomologarApi = (token) => {
  const { accessToken } = useAuth() || {};
  return new HomologarApi(token || accessToken);
};

export default useHomologarApi;
